import _ from 'lodash'
import { synchroniseMenuData } from '../../apis/shop.service'
import {
  createSection,
  deleteMenuSection,
  menuSynchronisation,
  updateSection,
  updateSectionActivation
} from '../../apis/backend'
import { showNotification } from '../../components/Notification/Notification.view'
import {
  ERROR_DUPLICATION,
  ERROR_SYNCHRONIZATION_WITH_SHOP,
  ERROR_SYNCHRONIZE_SHOPS_NOT_FOUND,
  ERROR_SYNCHRONIZE_WITH_POS,
  ERROR_UPDATE_SECTION,
  ERROR_WRONG_INFORMATIONS,
  NO_ACTIVE_DAY,
  SYNC_SHOPS
} from '../../constants'
import { setCopyKey, sortItemsPositionForShop } from '../../utils/product'
import { isStringNotNull, keyGenerator } from '../../utils/tools'
import { getDaysOfWeekForRange, getShopsToSynchronise } from '../../utils/shopUtils'
import { formatDate } from '../../utils/suitableDate'
import { getCroppedImg } from 'src/utils/image'
import { checkAccess } from 'src/utils/admins'

export const handleClose = component => {
  component.setState({
    sectionModalOpen: false,
    sectionUpdateModalOpen: false,
    productModalOpen: false,
    updateProductModalOpen: false,
    removeProductModal: false,
    removeSectionModal: false,
    section: {},
    product: {},
    selectedShops: {}
  })
}

export const handleNewSection = component => {
  component.setState({
    sectionModalOpen: true,
    searchTerm: '',
    croppedImage: {},
    section: {
      position: 0,
      name: '',
      description: '',
      hideProductName: false
    },
    sectionImage: [],
  })
}

export const handleMountSection = (e, section, component) => {
  const { name = '' } = section
  component.setState({
    sectionUpdateModalOpen: true,
    section,
    sectionName: name,
    sectionImage: []
  })
}
export const handleDuplicateSection = async (e, section, component) => {
  const { openErrorModal } = component.props
  section.key = setCopyKey(keyGenerator('SECTION'))
  for (let oldKey in section.products) {
    const key = keyGenerator('PRODUCT')
    const product = section.products[oldKey]
    delete section.products[oldKey]
    section.products[key] = { ...product, key }
  }
  try {
    await createSection(section)
  } catch (err) {
    openErrorModal(ERROR_DUPLICATION)
  }
}
export const handleSubmitSection = async (component) => {
  const { section, sectionModalOpen, synchronize = false, selectedShops } = component.state
  const { openErrorModal, sections } = component.props
  const { name, key = keyGenerator('SECTION'), activationRange = {} } = section
  let { position, products = null } = section
  const activeDays = getDaysOfWeekForRange(activationRange?.startDate, activationRange?.endDate)
  const daysOfWeek = _.pick(section?.activationRange?.daysOfWeek, activeDays)
  position = sectionModalOpen ? parseInt(_.size(sections), 10) : parseInt(position, 10)
  const nameToCkeck = name ? name.replace(/\s+/g, '') : ''
  const { formattedStartDate, formattedEndDate } = formatDate(activationRange?.startDate, activationRange?.endDate)
  if (activationRange?.withDateRange && _.size(daysOfWeek) === 0) {
    openErrorModal(NO_ACTIVE_DAY)
    return
  }
  if (
    nameToCkeck &&
    nameToCkeck.length > 0 &&
    position >= 0
  ) {
    try {
      component.setState({ isLoadingSection: true })
      const renderSection = {
        ...section,
        products,
        key,
        activationRange: activationRange?.withDateRange ? {
          ...section?.activationRange,
          daysOfWeek,
          hiddenOutsideOfRange: section.activationRange.hiddenOutsideOfRange || false,
          startDate: formattedStartDate,
          endDate: formattedEndDate
        } : null
      }

      const imageConfig = section?.imageConfig
      if (imageConfig) {
        const croppedImageUrl = await getCroppedImg(imageConfig.imageUrl, imageConfig.croppedAreaPixels)
        renderSection['image'] = croppedImageUrl.split(',')[1]
        if (imageConfig?.hasUserEdited) {
          renderSection.iconUrl = null;
          renderSection.iconCompressedUrl = null;
        }
      }
      delete renderSection.imageConfig

      if (!synchronize || (synchronize && _.size(selectedShops) > 1)) {
        if (sectionModalOpen) {
          await createSection(renderSection, Object.keys(selectedShops || {}))
        } else {
          await updateSection(renderSection, key, Object.keys(selectedShops || {}))
        }
        component.setState({
          sectionModalOpen: false,
          sectionUpdateModalOpen: false,
          isLoadingSection: false,
          showModal: false, synchronize: false
        })
      } else {
        openErrorModal(ERROR_SYNCHRONIZATION_WITH_SHOP)
        component.setState({ isLoadingSection: false })
      }

    } catch (err) {
      openErrorModal(ERROR_UPDATE_SECTION)
    }

  } else {
    openErrorModal(ERROR_WRONG_INFORMATIONS)

  }
  component.setState({ isLoadingSection: false, selectedShops: {} })

}
export const changeActivationSection = async (e, sectionKey) => {
  try {
    await updateSectionActivation(sectionKey, { hidden: !e.target.checked })
  } catch (err) {

  }
}
// ---- HANDLE REMOVE ---- //

export const handleRemoveSectionSubmit = async (sectionKey, component) => {
  const { shopId, openErrorModal, page, sections } = component.props
  const { synchronize = false, selectedShops } = component.state
  const { rowsPerPage, numPage } = page
  try {
    component.setState({ removeSectionModal: false })
    if (numPage > 0 && numPage * rowsPerPage >= _.size(sections) - 1) {
      component.props.updatePage(numPage - 1)
    }
    if (synchronize) {
      if (_.size(selectedShops) > 1) {
        component.setState({ isLoadingSection: true })
        await Promise.all( // perfs TODO create backend transactions
          Object.keys(selectedShops).map(shopId => deleteMenuSection(shopId, sectionKey))
        )
        await component.setState({ isSuppression: false, showModal: false, isLoadingSection: false })
        await closeDeleteModal(component)
      } else openErrorModal(ERROR_SYNCHRONIZATION_WITH_SHOP)

    } else { await deleteMenuSection(shopId, sectionKey); component.setState({ isloading: false, showModal: false }); closeDeleteModal(component) }

  } catch (error) {
    await component.setState({ isSuppression: false, showModal: false, isLoadingSection: false })
    await closeDeleteModal(component)
    openErrorModal(ERROR_UPDATE_SECTION)

  }
}
const closeDeleteModal = component => {
  const { showModal } = component.props
  component.setState({ synchronize: false, isSuppression: false, selectedShops: {} })
  showModal(null)
}
export const handleRemoveSection = (e, sectionKey, component) => {
  const { showModal, sections = {}, shopId, shops, nbShops } = component.props
  const nbShopsToSync = _.size(getShopsToSynchronise())
  const { name } = sections[sectionKey]
  const modalData = {
    color: 'danger',
    title: `Êtes-vous sûr(e) de vouloir supprimer la section ${name?.toLowerCase()} ?`,
    message: 'Tous les produits associés seront eux aussi supprimés !',
    showCancelBtn: true,
    checkboxes: nbShops > 1 && nbShopsToSync > 1 && checkAccess('features', 'globalProduct') ?
      [{
        text: 'Supprimer cette section sur un ou plusieurs magasins',
        onChange: checked => {
          component.setState({ synchronize: checked })
        }
      }] : [],
    handleClose: () => {
      closeDeleteModal(component)
    },
    btnColor: 'danger',
    onClick: () => {
      component.state.synchronize && nbShops > 1 && nbShopsToSync > 1 ?
        component.setState({
          selectedShops: { [shopId]: shops[shopId] },
          showModal: true,
          sectionKey
        }) :
        handleRemoveSectionSubmit(sectionKey, component);
      showModal({
        ...modalData,
        loading: true
      });
    },
    btnTxt: 'Supprimer'
  }
  showModal(modalData)
}

export const handleChangeSection = ({ target }, component) =>
  component.setState(prevState => ({
    section: { ...prevState.section, [target.id]: target.value }
  }))

export const handleRemoveImage = component => {
  component.setState(prevState => ({
    section: { ...prevState.section, iconUrl: '', image: '', imageConfig: null }
  }));
};
export const handleDragSection = async (event, sections, component) => {
  const { openErrorModal } = component.props
  const { active, over } = event
  if (active?.id !== over?.id) {
    try {

      await sortItemsPositionForShop(event, sections)
      component.setState({
        activeId: null
      })
    } catch (err) {
      openErrorModal(ERROR_UPDATE_SECTION)
    }
  }
}

export const handleChangeExpend = (event, expanded, panel, component) => {
  const { target = {} } = event
  const { localName = {} } = target
  const balise = localName
  if (balise !== 'path' && balise !== 'svg') {
    component.setState({
      expanded: expanded ? panel : false
    })
  }
}

export const setCroppedImage = async (croppedImage, component) => {
  component.setState(prevState => ({
    section: { ...prevState.section, image: croppedImage.split(',')[1] }
  }));
};

export const setImageConfig = async (configObject, component) => {
  component.setState(prevState => ({
    section: { ...prevState.section, imageConfig: configObject }
  }));
};

export const handleStartDrag = (event, component) => {
  component.setState({ activeId: event.active.id })
}

export const showConfirmation = async (component, index) => {
  const { showModal, shops, generalAdmin } = component.props
  let resetMenu = false
  let resetPrice = false
  let updatePaymentTypes = false
  const title = `Êtes-vous sûr(e) de vouloir ${index === SYNC_SHOPS
    ? 'synchroniser votre menu sur vos magasins'
    : 'récupérer le menu depuis la caisse (POS)'
    }?`
  const isAllowedToUpdateMenuProperties = generalAdmin && index !== SYNC_SHOPS
  const resetPriceCheckbox = (disabled) => ({
    id: 'resetPrice',
    disabled,
    resetWhenDisabled: true,
    text: 'Remplacer les prix des éléments du menu existant par ceux de la caisse',
    onChange: (priceChecked) => {
      resetPrice = priceChecked
    },
  })
  const resetMenuCheckBox = {
    id: 'resetMenu',
    text: 'Remplacer le menu existant par celui de la caisse',
    onChange: (checked) => {
      resetMenu = checked
      checkboxes.splice(2, 1, resetPriceCheckbox(checked))
      resetPrice = false
      showModal({ ...modalData, checkboxes })
    }
  }
  const updatePaymentTypesCheckbox = {
    id: 'updatePaymentTypes',
    text: 'Récupérer les références des types de paiements',
    onChange: (checked) => {
      updatePaymentTypes = checked
    },
  }
  const baseCheckboxes = [
    resetMenuCheckBox,
    updatePaymentTypesCheckbox,
    resetPriceCheckbox(false)
  ]
  let checkboxes = [...baseCheckboxes]
  const modalData = {
    title,
    showCancelBtn: true,
    checkboxes: isAllowedToUpdateMenuProperties && checkAccess('features', 'globalProduct') ? checkboxes : [],
    btnTxt: 'Synchroniser',
  }
  const onClick = async () => {
    if (index === SYNC_SHOPS) {
      await synchronizingData(component, shops)
    } else {
      await synchronisationWithPos(
        component,
        resetMenu,
        resetPrice,
        updatePaymentTypes,
        modalData
      )
    }
  }
  modalData.onClick = onClick
  handleCloseMenu(component)
  showModal(modalData)
}

export const synchronisationWithPos = async (component, resetMenu, resetPrice, updatePaymentTypes, modalData) => { // TODO bad naming, bad param naming, typo
  const { openErrorModal, showModal } = component.props
  try {
    component.setState({ loading: true, isLoadingSection: true })
    showModal({ ...modalData, loading: true })
    const response = await menuSynchronisation(resetMenu, resetPrice, updatePaymentTypes)
    if (response.status === 202) {
      showNotification(
        'light',
        'ltr',
        'primary',
        'Synchronisation réussie',
        `Votre menu a bien été synchronisé avec le menu de la caisse.`
      )
    } else openErrorModal(ERROR_SYNCHRONIZE_WITH_POS)
    component.setState({ showModal: false })
  } catch (err) {
    openErrorModal(ERROR_SYNCHRONIZE_WITH_POS)
  }
  showModal(null)
  component.setState({ loading: false, isLoadingSection: false })
}

export const synchronizingData = async (component, shopsMenu) => { // TODO bad naming, bad param naming, typo
  const { openErrorModal, showModal } = component.props
  const shopIds = _.keys(shopsMenu)
  try {
    if (_.size(shopsMenu) > 1) {
      component.setState({ loading: true, isLoadingSection: true })
      await synchroniseMenuData(shopIds)
      showNotification(
        'light',
        'ltr',
        'primary',
        'Synchronisation réussie',
        `Votre menu a bien été synchronisé sur tous vos magasins séléctionnés.`
      )
      component.setState({ showModal: false })
    } else {
      openErrorModal(ERROR_SYNCHRONIZATION_WITH_SHOP)
      component.setState({ loading: false, isLoadingSection: false })
    }

  } catch (err) {
    openErrorModal(ERROR_SYNCHRONIZE_SHOPS_NOT_FOUND)
  }
  showModal(null)
  component.setState({ loading: false, isLoadingSection: false })
}
export const sortedSections = (component, rowsPerPage = 0) => {
  const { page } = component.props;
  const sections = getSections(component);
  const { numPage } = page;

  return _.keys(sections)
    .sort((a, b) => sections[a].position - sections[b].position)
    .slice(
      numPage * rowsPerPage,
      rowsPerPage ? numPage * rowsPerPage + rowsPerPage : _.size(sections)
    )
    .reduce((obj, cur) => ({ ...obj, [cur]: sections[cur] }), {})
}
export const handleDisplayMenu = (event, component) => {
  component.setState({ anchorEl: event.currentTarget, searchTerm: '' })
}

export const handleCloseMenu = component => {
  component.setState({ anchorEl: null })
}
export const handleSearchChange = async (e, component) => {
  await component.setState({ searchTerm: e.target.value })
  getSections(component)
}

export const getSections = (component) => {
  const { sections = {} } = component.props
  const clonedSections = _.cloneDeep(sections)
  const searchTerm = component.state.searchTerm.toLowerCase()
  return !isStringNotNull(searchTerm) ? clonedSections : _.pickBy(clonedSections, (section) => {
    const filteredProducts = _.pickBy(section?.products, (product) =>
      product?.name?.toLowerCase().includes(searchTerm)
    )
    if (_.size(filteredProducts) > 0) {
      section.products = filteredProducts
      return true
    }
    return false

  })
}


